module.exports = __webpack_public_path__ + "static/media/faq-8.6ac373ef.png";